import { DmStagingApiError } from './dm-staging.js';
export async function getMemberFinancialAccount(base, memberId, signal) {
    let response;
    try {
        response = await fetch(`${base.replace(/\/$/, '')}/identity/collections/members/${memberId}/account`, { credentials: 'include', headers: { Accept: 'application/json' }, signal: signal ?? null });
    }
    catch {
        throw new DmStagingApiError('unavailable', 'No pudimos consultar el estado de cuenta.');
    }
    if (!response.ok) {
        const problem = (await response.json().catch(() => null));
        throw new DmStagingApiError(response.status === 401
            ? 'unauthorized'
            : response.status === 403
                ? 'forbidden'
                : 'unavailable', problem?.message ?? `No pudimos consultar el estado de cuenta (HTTP ${response.status}).`);
    }
    return (await response.json());
}
export const memberPaymentReceiptUrl = (base, memberId, paymentId) => `${base.replace(/\/$/, '')}/identity/collections/members/${memberId}/payments/${paymentId}/receipt`;
export const memberSelfPaymentReceiptUrl = (base, paymentId) => `${base.replace(/\/$/, '')}/identity/member-self/payments/${paymentId}/receipt`;
export const memberSelfPaymentReceiptDownloadUrl = (base, paymentId) => `${base.replace(/\/$/, '')}/identity/member-self/payments/${paymentId}/official-receipt`;
export const memberOfficialPaymentReceiptUrl = (base, memberId, paymentId) => `${base.replace(/\/$/, '')}/identity/collections/members/${memberId}/payments/${paymentId}/official-receipt`;
export async function uploadMemberPaymentReceipt(base, memberId, paymentId, file, reason) {
    if (reason.trim().length < 10)
        throw new Error('Explica el motivo de la carga con al menos 10 caracteres.');
    const body = new FormData();
    body.append('file', file);
    const response = await fetch(memberPaymentReceiptUrl(base, memberId, paymentId), {
        method: 'POST',
        credentials: 'include',
        body,
        headers: { Accept: 'application/json', 'x-urbanik-reason': encodeURIComponent(reason.trim()) },
    });
    const result = await response.json().catch(() => null);
    if (!response.ok)
        throw new Error(result?.message ?? 'No se pudo cargar el comprobante.');
    return result;
}
export async function getAvailablePaymentReceipts(base, memberId, paymentId, query = '') {
    const url = new URL(`${base.replace(/\/$/, '')}/identity/collections/members/${memberId}/payments/${paymentId}/receipts/available`);
    if (query.trim())
        url.searchParams.set('q', query.trim());
    const response = await fetch(url, {
        credentials: 'include',
        headers: { Accept: 'application/json' },
    });
    const result = (await response.json().catch(() => null));
    if (!response.ok)
        throw new Error(result?.message ?? 'No se pudieron consultar los comprobantes registrados.');
    return result?.items ?? [];
}
export async function linkExistingPaymentReceipt(base, memberId, paymentId, receiptId, reason) {
    const response = await fetch(`${base.replace(/\/$/, '')}/identity/collections/members/${memberId}/payments/${paymentId}/receipt-links`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ receiptId, reason: reason.trim() }),
    });
    const result = await response.json().catch(() => null);
    if (!response.ok)
        throw new Error(result?.message ?? 'No se pudo vincular el comprobante.');
    return result;
}
